export const CONTROLS_HEIGHT = 42
export const EXTRA_SPACE = 5
